import { useNavigate } from "react-router-dom";

import LaunchIcon from "@mui/icons-material/Launch";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";
import useTheme from "@mui/material/styles/useTheme";

import { misc, neutral } from "app/themes/colors";
import useSunoDialer from "components/suno-dialer/use-suno-dialer.hook";
import { BAS } from "constants/patients";

export default function TitleBlock() {
  const theme = useTheme();
  const navigate = useNavigate();

  const { outgoingCall, isExpanded } = useSunoDialer();
  const patient = outgoingCall?.patient;

  if (!patient) return null;

  return (
    <Stack
      justifyContent="space-between"
      direction="row"
      sx={{ p: 2, pt: 0.5, pb: 1 }}
    >
      <Stack
        sx={{
          background: "white",
          p: 1.5,
          borderRadius: "16px",
          boxShadow: theme.shadows[3],
          width: "100%",
          cursor: "pointer",

          "&:hover": {
            boxShadow: theme.shadows[0]
          }
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <Avatar
            alt="avatar"
            src={patient?.avatar || ""}
            sx={{
              cursor: "pointer",
              width: "70px",
              height: "70px"
            }}
            slotProps={{ img: { loading: "lazy" } }}
          />

          <Stack
            width="100%"
            height="100%"
            sx={{ pl: 1, boxSizing: "border-box" }}
            justifyContent="center"
          >
            <Link
              href={`/patients/${patient?.id}`}
              sx={{
                width: "fit-content",
                color: neutral[900],
                textDecorationColor: neutral[500],

                "&:hover": {
                  textDecoration: misc.purpleText
                }
              }}
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                navigate(`/patients/${patient?.id}`);
              }}
            >
              <Typography
                component="span"
                sx={{
                  fontSize: "17px",
                  lineHeight: 1.3
                }}
              >
                {patient.fullName}
                <IconButton
                  size="small"
                  sx={{
                    ml: -0.5,
                    mt: -0.8,
                    transform: "scale(0.6)",
                    opacity: 0.5,
                    "&:hover": {
                      color: misc.purpleText,
                      opacity: 1
                    }
                  }}
                >
                  <LaunchIcon />
                </IconButton>
              </Typography>
            </Link>
            {isExpanded && Boolean(patient?.sex || patient?.age_years) && (
              <Typography
                sx={{
                  fontSize: "13px",
                  lineHeight: 1.1,
                  color: grey[800]
                }}
              >
                {[
                  BAS.getFromCode(patient?.sex),
                  patient?.age_years ? `${patient?.age_years} years old` : ""
                ]
                  .filter(Boolean)
                  .join(", ")}
              </Typography>
            )}
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}
